import { Box, Typography, useTheme } from '@mui/material';
import { flexCenter } from '../commonUI/cssClasses';

export interface ImageInfoProps {
  label: string;
  loading?: boolean;
  error?: Error | null;
  children: React.ReactNode | undefined;
}

const placeholder = (
  <Typography
    variant='subtitle1'
    sx={{
      ...flexCenter,
      color: (theme) => theme.colors.common.softWhite,
      p: '0.2rem',
      lineHeight: 1,
      whiteSpace: 'nowrap',
      fontWeight: 'bold',
      fontSize: {
        sm: '1.2rem',
        md: '1.4rem',
        lg: '1.6rem',
      },
    }}
  >
    --
  </Typography>
);

const ImageInfoSlot: React.FC<ImageInfoProps> = ({ label, children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.colors.darkTheme.grey.medium,
        borderRadius: theme.borderRadius.primary,
        p: '1rem',
        ml: '16px',
      }}
    >
      <Typography
        variant='subtitle1'
        sx={{
          ...flexCenter,
          color: theme.colors.common.softWhite,
          p: '0 0.5rem',
          whiteSpace: 'nowrap',
          fontSize: {
            sm: '0.6rem',
            md: '0.8rem',
            lg: '0.9rem',
          },
        }}
      >
        {label}
      </Typography>
      <Box sx={{ ...flexCenter, minHeight: '2rem', flexDirection: 'row' }}>
        {children ?? placeholder}
        {/* {loading ? (
          <LoadingSpinner />
        ) : error ? (
          <Typography
            variant='subtitle1'
            sx={{
              ...flexCenter,
              color: (theme) => theme.colors.common.softWhite,
              p: '0.2rem',
              lineHeight: 1,
              whiteSpace: 'nowrap',
              fontWeight: 'bold',
              fontSize: {
                sm: '1.2rem',
                md: '1.4rem',
                lg: '1.6rem',
              },
            }}
          >
            Error
          </Typography>
        ) : (
          children
        )} */}
      </Box>
    </Box>
  );
};

export default ImageInfoSlot;
